<app-not-authorized-notice has="userRoleManagement"></app-not-authorized-notice>

<app-user-search-bar
	[searchAllUsers]="true"
	(selectedUserEvents)="onSelectedEvent($event)"
	[appHasSystemCapability]
	has="userRoleManagement"
></app-user-search-bar>
